import './log-viewer.css';
export default {
  "button": "pf-c-button",
  "card": "pf-c-card",
  "logViewer": "pf-c-log-viewer",
  "logViewerHeader": "pf-c-log-viewer__header",
  "logViewerIndex": "pf-c-log-viewer__index",
  "logViewerList": "pf-c-log-viewer__list",
  "logViewerListItem": "pf-c-log-viewer__list-item",
  "logViewerMain": "pf-c-log-viewer__main",
  "logViewerScrollContainer": "pf-c-log-viewer__scroll-container",
  "logViewerString": "pf-c-log-viewer__string",
  "logViewerText": "pf-c-log-viewer__text",
  "logViewerTimestamp": "pf-c-log-viewer__timestamp",
  "modifiers": {
    "dark": "pf-m-dark",
    "wrapText": "pf-m-wrap-text",
    "nowrap": "pf-m-nowrap",
    "lineNumbers": "pf-m-line-numbers",
    "lineNumberChars": "pf-m-line-number-chars",
    "match": "pf-m-match",
    "current": "pf-m-current"
  },
  "searchInput": "pf-c-search-input",
  "themeDark": "pf-theme-dark",
  "toolbar": "pf-c-toolbar",
  "toolbarContentSection": "pf-c-toolbar__content-section"
};